import React from 'react'
import Link from 'gatsby-link'

const Introduction = () => (
  <div
    style={{
      margin: '1.45rem 0',
      padding: '80px 0'
    }}
  >
    <div className="container">
      <div className="row">
        <div className="col-lg-10 offset-lg-1 text-center">

          <div className="row">
            <div className="col-lg-9">
              <h1>Welcome to Ridley Owen &amp; Sons</h1>

              <p>Here at Ridley Owen &amp; sons we are always willing to go that extra mile,
                be it friendly advice or help with your plans we have the experience and
                expertise to make your project happen.</p>
                
              <p>Being a small family run business be rest assured that when dealing with us
                you get that personal touch that other big companies cannot provide. We cover
                small building works/ refurbishments and maintenance and have the wealth of
                knowledge to ensure your happy with the service we can give you.</p>
            </div>
            <div className="col-lg-3">
              <img
                src={require('./safe_contractor_seal.png')}
                className="img-fluid"
                style={{
                  marginTop: 20,
                  maxWidth: 160
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Introduction


// WEBPACK FOOTER //
// ./src/components/Introduction/index.js